export const CONTACT_CATEGORIES = [
  { value: "support", label: "Support" },
  { value: "sales", label: "Sales" },
  { value: "security", label: "Security" },
  { value: "other", label: "Other" },
] as const;

export type ContactCategory = (typeof CONTACT_CATEGORIES)[number]["value"];

export const VALID_CATEGORIES = CONTACT_CATEGORIES.map((c) => c.value) as readonly ContactCategory[];
